import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoChevronLeftBig24 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type NavigationBackButtonProps = {
  onBack?: () => void;
  color?: Color;
};
const NavigationBackButton = t0 => {
  const $ = _c(7);
  const {
    onBack,
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "shell.global.components.navigation-header.back-button"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== color || $[4] !== onBack || $[5] !== t2) {
    t3 = <IconButton aria-label={t2} onClick={onBack} icon={IcoChevronLeftBig24} color={color} />;
    $[3] = color;
    $[4] = onBack;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default NavigationBackButton;
function _temp($) {
  return $["aria-label"];
}